var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.isDroppable ? 'fade' : null}},[(_vm.enabled)?_c('drop-helper',{attrs:{"dropOptions":_vm.dropOptions}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }